module.exports = __webpack_public_path__ + "static/image/live_dynamic.gif?43aca124a8d3b9d502ea6302c90902d9";